<template>
  <div class="codepen">
    <div :class="{ wysiwyg: !content.isLarge }">
      <component :is="cpt" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'
import { compile, h, PropType } from 'vue'

type Content = {
  htmltext: string
  isLarge: boolean
}

useHead({
  script: [
    { src: 'https://cpwebassets.codepen.io/assets/embed/ei.js', async: true },
  ],
})

const props = defineProps({
  content: {
    type: Object as PropType<Content>,
    required: true,
  },
})

const cpt = h(compile(props.content.htmltext))
</script>

<style lang="scss" scoped>
.wysiwyg {
  margin: auto;

  @include mq(l) {
    width: col(8);
  }

  @include mq($until: l) {
    width: 100%;
  }
}
</style>
